module.exports = __webpack_public_path__ + "static/media/apertum_logo-with-text.5d88b41b.svg";